import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Header from "./Header";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import "./Accomodation.css";
import Navbar from "./Navbar";
import host from "../config";
// const host = "https://api.vmrdarental.com";
// const host = "http://13.203.181.236:3000";
// const host = "https://api.vmrdarental.com";

const CancellationReports = () => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [cancellationDetails, setCancellationDetails] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("bookingDate");
  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  const [checkInStartDate, setCheckInStartDate] = useState(null);
  const [checkInEndDate, setCheckInEndDate] = useState(null);
  // const [cancelled, setCancelled] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    // Redirect to login if access token is missing or user is not authorized
    if (
      !localStorage.getItem("access_token") ||
      localStorage.getItem("access_token") === "" ||
      localStorage.getItem("userRole") != 1
    ) {
      navigate("/Home", "_self");
    }
  }, [navigate]);

  const handleFilter = () => {
    const formattedStartDate = startDate
      ? moment(startDate).format("DD-MMM-YYYY")
      : "";
    const formattedEndDate = endDate
      ? moment(endDate).format("DD-MMM-YYYY")
      : "";
    const formattedCheckInStartDate = checkInStartDate
      ? moment(checkInStartDate).format("DD-MMM-YYYY")
      : "";
    const formattedCheckInEndDate = checkInEndDate
      ? moment(checkInEndDate).format("DD-MMM-YYYY")
      : "";

    let url = `${host}/api/cancelled-data`;
    if (selectedFilter === "bookingDate" && startDate && endDate) {
      url += `?startBookingDate=${formattedStartDate}&endBookingDate=${formattedEndDate}`;
    } else if (
      selectedFilter === "checkInDate" &&
      checkInStartDate &&
      checkInEndDate
    ) {
      url += `?startCheckInDate=${formattedCheckInStartDate}&endCheckOutDate=${formattedCheckInEndDate}`;
    }

    fetch(url)
      .then((response) => response.json())
      .then((data) => setCancellationDetails(data))
      .catch((error) => console.error("Error fetching data:", error));
  };
  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(cancellationDetails);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "CancellationDetails");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "cancellationdetails.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "px",
      format: "a4",
    });

    doc.setProperties({
      title: "VMRDA Reports",
    });

    const headingText = "VMRDA Reports";
    const fontSize = 18;
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth =
      (doc.getStringUnitWidth(headingText) * fontSize) /
      doc.internal.scaleFactor;
    const textX = (pageWidth - textWidth) / 2;
    doc.setFontSize(fontSize);
    doc.text(headingText, textX, 40);

    const subtitleText = `Cancellation Details Reports`;
    const subtitleFontSize = 16;
    const subtitleWidth =
      (doc.getStringUnitWidth(subtitleText) * subtitleFontSize) /
      doc.internal.scaleFactor;
    const subtitleX = (pageWidth - subtitleWidth) / 2;
    doc.setFontSize(subtitleFontSize);
    doc.text(subtitleText, subtitleX, 60);

    const tableColumn = [
      //   "Booking ID",
      // " ID",
      "Customer ID",
      "Venue Name",
      "Venue Type",
      "Date",
      "Venue Amount",
      // "Extra Persons",
      "Subtotal",
      "Booking Time",
      "Created By",
      "Cancellation Date",
      // "Payment Mode",
      // "Razorpay Order ID",
      // "Razorpay Payment ID",
      // "Refund Amount",
    ];

    const tableRows = cancellationDetails.map((detail) => [
      //   detail.booking_id,
      // detail.room_id,
      detail.customer_id,
      detail.room_name,
      detail.room_type,
      new Date(detail.date).toLocaleDateString(),
      detail.room_amount,
      // detail.extra_persons,
      detail.sub_total,
      new Date(detail.created_ts).toLocaleDateString(),
      // detail.created_ts,

      detail.created_by,
      new Date(detail.cancellation_date).toLocaleDateString(),
      // detail.payment_mode,
      // detail.razorpay_order_id,
      // detail.razorpay_payment_id,
      // detail.Refund_amount,
    ]);

    doc.autoTable(tableColumn, tableRows, { startY: 80 });
    doc.save("cancellationdetails.pdf");
  };

  const filteredBookings = cancellationDetails.filter((detail) => {
    const values = Object.values(detail).join(" ").toLowerCase();
    return values.includes(searchTerm.toLowerCase());
  });

  return (
    <div>
      <div className="container">
        <div className="row">
          {/* <div className="col-lg-2"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 content_back">
            <div className="row">
              <b className="text-center" style={{ fontSize: "20px" }}>
                VMRDA Cancellation Reports
              </b>
            </div>
            <br />
           
            <div className="filters">
              <label htmlFor="filter">Filter By:</label>
              <select
                id="filter"
                value={selectedFilter}
                onChange={(e) => setSelectedFilter(e.target.value)}
              >
                <option value="bookingDate">Booking Date</option>
                <option value="checkInDate">Check In Dates</option>
              </select>

              {selectedFilter === "bookingDate" && (
                <>
                  <label>From:</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="DD-MMM-YYYY"
                  />
                  <label>To:</label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="DD-MMM-YYYY"
                  />
                </>
              )}

              {selectedFilter === "checkInDate" && (
                <>
                  <label>From:</label>
                  <DatePicker
                    selected={checkInStartDate}
                    onChange={(date) => setCheckInStartDate(date)}
                    selectsStart
                    startDate={checkInStartDate}
                    endDate={checkInEndDate}
                    dateFormat="DD-MMM-YYYY"
                  />
                  <label>To:</label>
                  <DatePicker
                    selected={checkInEndDate}
                    onChange={(date) => setCheckInEndDate(date)}
                    selectsEnd
                    startDate={checkInStartDate}
                    endDate={checkInEndDate}
                    dateFormat="DD-MMM-YYYY"
                  />
                </>
              )}
              <button
                type="button"
                className="btn-primary"
                onClick={handleFilter}
                style={{ borderRadius: "20px" }}
              >
                Submit
              </button>
            </div>
            {filteredBookings.length > 0 ? (
              <>
                <div className="download-buttons">
                  <button
                    style={{ borderRadius: "20px" }}
                    className="btn-primary"
                    onClick={downloadExcel}
                  >
                    Download Excel
                  </button>
                  <button
                    style={{ borderRadius: "20px" }}
                    className="btn-primary"
                    onClick={downloadPDF}
                  >
                    Download PDF
                  </button>
                </div>
                <div>
                  <div className="search-bar">
                    <label htmlFor="search">Search:</label>
                    <input
                      type="text"
                      id="search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Search bookings..."
                      style={{
                        marginLeft: "10px",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                </div>
                <table className="table table-responsive">
                  <thead>
                    <tr>
                      {/* <th>Booking ID</th> */}
                      {/* <th>Room ID</th> */}
                      <th>Customer ID</th>
                      <th>Venue Name</th>
                      <th>Venue Type</th>
                      <th>Check In Date</th>
                      <th>Venue Amount</th>

                      {/* <th>Extra Persons</th> */}
                      <th>Subtotal</th>
                      <th>Booking Date</th>
                      {/* <th>Created By</th> */}
                      <th>Cancellation Date</th>
                   
                    </tr>
                  </thead>
                  <tbody>
                    {filteredBookings.map((detail) => (
                      <tr key={detail.booking_id}>
                        {/* <td>{detail.booking_id}</td> */}
                        {/* <td>{detail.room_id}</td> */}
                        <td>{detail.customer_id}</td>
                        <td>{detail.room_name}</td>
                        <td>{detail.room_type}</td>
                        <td>{new Date(detail.date).toLocaleDateString()}</td>
                        <td>{detail.room_amount}</td>

                        {/* <td>{detail.extra_persons}</td> */}
                        <td>{detail.sub_total}</td>
                        <td>
                          {new Date(detail.created_ts).toLocaleDateString()}
                        </td>
                        {/* <td>{detail.created_ts}</td> */}
                        {/* <td>{detail.created_by}</td> */}
                        <td>
                          {new Date(
                            detail.cancellation_date
                          ).toLocaleDateString()}
                        </td>
                       
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            ) : (
              <p>No cancellation details found for the selected dates.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationReports;
